export const environment = {
  production: true,
  url: 'https://api.modernamedia.no',
  // url: 'https://localhost:5001',
  img: 'https://modernamedia.b-cdn.net/',
};
